import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFloatingAlert from 'UIComponents/alert/UIFloatingAlert';
import UILink from 'UIComponents/link/UILink';
import { useDispatch } from 'react-redux';
import { Step } from 'signup-constants/Step';
import styled from 'styled-components';
import { fetchExistingAccounts } from '../store/existing-accounts/action-creators';
import { getSentryExtra } from '../error/getSentryExtra';
import { LOG } from '../http/HttpRequester';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLink = styled(UILink).withConfig({
  displayName: "ExistingAccountsErrorModal__StyledLink",
  componentId: "sc-9am4qj-0"
})(["margin-left:12px;"]);
const StyledTitle = styled(FormattedMessage).withConfig({
  displayName: "ExistingAccountsErrorModal__StyledTitle",
  componentId: "sc-9am4qj-1"
})(["font-weight:700;"]);
const Wrapper = styled.div.withConfig({
  displayName: "ExistingAccountsErrorModal__Wrapper",
  componentId: "sc-9am4qj-2"
})(["display:flex;margin:auto;justify-content:center;"]);
const ExistingAccountsErrorModal = () => {
  const dispatch = useDispatch();
  const handleLinkClick = () => {
    dispatch(fetchExistingAccounts()).catch(error => {
      LOG.error('Error retrying fetching existing user accounts', {
        extra: getSentryExtra(error)
      });
    });
  };
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsxs(UIFloatingAlert, {
      type: "warning",
      children: [/*#__PURE__*/_jsx(StyledTitle, {
        message: `views.${Step.ExistingAccounts}.errorModal.text`
      }), /*#__PURE__*/_jsx(StyledLink, {
        onClick: handleLinkClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `views.${Step.ExistingAccounts}.errorModal.retry`
        })
      })]
    })
  });
};
export default ExistingAccountsErrorModal;